import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../../lib/api";

export function ManagerFinancialTab() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/manager/financial/team-summary")
      .then(({ data }) => setData(data))
      .catch((e) => toast.error(formatApiErrorDetail(e.response?.data?.detail)));
  }, []);

  if (!data) return null;

  return (
    <div data-testid="manager-financial-tab" className="space-y-8 max-w-4xl">
      <div>
        <h2 className="font-serif text-xl text-igc-cream tracking-tight mb-4" title="What you personally earn — override on your team's deals plus commission on any deals you close yourself.">Your Earnings</h2>
        <div className="grid grid-cols-3 gap-4">
          <div className="bg-igc-surface border border-igc-gold/15 p-5" data-testid="manager-financial-override-earned">
            <p className="text-igc-muted text-xs uppercase tracking-widest mb-2" title="Your automatic commission on every deal your team closes.">Override Earned</p>
            <p className="font-serif text-2xl text-igc-goldText">${data.manager_earnings.override_earned.toLocaleString()}</p>
          </div>
          <div className="bg-igc-surface border border-igc-gold/15 p-5" data-testid="manager-financial-own-deals">
            <p className="text-igc-muted text-xs uppercase tracking-widest mb-2" title="Commission you earned on deals you personally closed.">Own Deals Commission</p>
            <p className="font-serif text-2xl text-igc-cream">${data.manager_earnings.own_deals_commission.toLocaleString()}</p>
          </div>
          <div className="bg-igc-surface border border-igc-gold/15 p-5" data-testid="manager-financial-total">
            <p className="text-igc-muted text-xs uppercase tracking-widest mb-2" title="Override Earned plus Own Deals Commission combined.">Total</p>
            <p className="font-serif text-2xl text-igc-success">${data.manager_earnings.total.toLocaleString()}</p>
          </div>
        </div>
      </div>

      <div>
        <h2 className="font-serif text-xl text-igc-cream tracking-tight mb-1" title="Commission earned by each individual rep on your team.">Team Commission Rollup</h2>
        <p className="text-igc-muted text-xs mb-4">Commission totals for each rep on your team. IGC's lender fees and retained amounts aren't shown here.</p>
        {data.team_rollup.length === 0 ? (
          <p className="text-igc-muted text-sm" data-testid="manager-financial-no-reps">No reps on your team yet.</p>
        ) : (
          <div className="bg-igc-surface border border-igc-gold/15 divide-y divide-igc-gold/10" data-testid="manager-financial-team-list">
            {data.team_rollup.map((r) => (
              <div key={r.rep_id} className="flex items-center justify-between px-4 py-3 text-sm" data-testid={`manager-financial-rep-row-${r.rep_id}`}>
                <div>
                  <span className="text-igc-cream">{r.rep_display_name}</span>
                  <span className="text-igc-muted text-xs ml-2">{r.rep_code}</span>
                  <span className={`text-[10px] ml-2 px-1.5 py-0.5 ${r.tier === "full_partner" ? "bg-igc-success/10 text-igc-success" : "bg-igc-gold/15 text-igc-goldText"}`}>{r.tier === "full_partner" ? "Full Partner" : "Starter"}</span>
                </div>
                <div className="flex items-center gap-4">
                  <span className="text-igc-muted text-xs">{r.deal_count} deal{r.deal_count === 1 ? "" : "s"}</span>
                  <span className="font-serif text-igc-cream">${r.total_commission.toLocaleString()}</span>
                </div>
              </div>
            ))}
          </div>
        )}
        <div className="mt-4 flex gap-6 text-sm text-igc-muted" data-testid="manager-financial-team-totals">
          <span>Team Total: <span className="text-igc-cream font-medium">${data.team_totals.total_rep_commission.toLocaleString()}</span></span>
          <span>Deals: <span className="text-igc-cream font-medium">{data.team_totals.total_deals}</span></span>
        </div>
      </div>
    </div>
  );
}
